import classNames from 'classnames';

import ButtonIcon, { propTypes } from '~/components/ButtonIcons/ButtonIcon';

import closeBordered from '~/assets/images/buttons/closev2.svg';

import styles from './ButtonIcon.module.scss';

const CloseBorderedButton = ({ className, ...props }) => (
  <ButtonIcon
    {...props}
    className={classNames(styles.button, styles.background, className)}
  >
    <img
      src={closeBordered}
      alt="close"
    />
  </ButtonIcon>
);

CloseBorderedButton.propTypes = propTypes;

export default CloseBorderedButton;
